angular.module('SpidApp')

.constant('InventoryAdapterConfig', {
  name : 'Inventory',
  fields : [
    {
        local   : 'id',
        distant : 'id'
    }, {
    	local   : 'user_id',
    	distant : 'user_id'
    }, {
    	local   : 'agency_id',
    	distant : 'agency_id'
    }, {
    	local   : 'products',
    	distant : 'products'
    }, {
        local   : 'type',
        distant : 'type'
    }, {
        local   : 'diffStock',
        distant : 'diffStock'
    }, {
        local   : 'diffInventory',
        distant : 'diffInventory'
    }, {
    	local   : 'updated_at',
    	distant : 'updated_at'
    }
  ]
})